'use client'

import { BuilderBlocks } from '@builder.io/react'
import type { ReactNode } from 'react'
import { memo } from 'react'

import { type RailProps } from '@src/components/Rail/Rail.props'
import { RailItemContextProvider } from '@src/components/Rail/RailItemContext'
import { cn } from '@src/utils/tailwind'

type Props = {
  blocks?: ReactNode[] | ReactNode
  builderBlock?: any
  imageStyle?: RailProps['imageStyle']
  index: number
  isPreviewing?: boolean
  columnsDesktop: number
  slug?: string
}

const RailItemBase = (props: Props) => {
  const { blocks, builderBlock, imageStyle, index, isPreviewing, columnsDesktop, slug } = props

  const imageClasses = cn(
    '[&_.rail-img]:relative [&_.rail-img]:overflow-hidden',
    '[&_.rail-img_img]:absolute [&_.rail-img_img]:inset-0 [&_.rail-img_img]:object-cover',
    '[&_.rail-img_img]:size-full',
    '[&_.rail-img]:rounded-[14px] lg:[&_.rail-img]:rounded-[30px]',
    {
      '[&_.rail-img]:aspect-square': imageStyle === 'square',
      '[&_.rail-img]:aspect-[250/171]': imageStyle === 'horizontal',
      '[&_.rail-img]:aspect-[250/309]': imageStyle === 'vertical',
      'lg:[&_.rail-img]:rounded-[14px]': columnsDesktop >= 5,
    }
  )

  const previewClasses = cn({
    'before:content-["Item_"attr(data-index)] before:absolute before:w-full before:top-0 before:px-2 before:rounded-sm  before:font-bold before:-translate-y-full before:-translate-x-1/2 before:left-1/2 before:bg-blue-50 before:text-blue-950':
      isPreviewing,
  })

  return (
    <div data-index={index + 1} className={cn('relative h-full', imageClasses, previewClasses)}>
      <RailItemContextProvider slug={slug} position={index + 1}>
        <BuilderBlocks
          className="h-full justify-between"
          parentElementId={builderBlock?.id}
          blocks={blocks}
          dataPath={`component.options.items.${index}.blocks`}
        />
      </RailItemContextProvider>
    </div>
  )
}

export const RailItem = memo(RailItemBase)
